import { HttpVerbs } from 'types/HttpVerbs';
import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
import { Validator, VARIABLE_VALIDATION_REGEX } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
export class ProcessHttpActionSettingsValidator extends Validator {
    validate(model) {
        if (!model.method) {
            throw new ValidationError('The HTTP method is required');
        }
        if (!model.uri) {
            throw new ValidationError('The HTTP URI is required');
        }
        if (!model.uri.match(/^((http|https):\/\/[^ "]+|\{\{[A-Za-z0-9\.@\[\]]+\}\}[^ "]*)$/)) {
            throw new ValidationError('The specified HTTP URI is invalid');
        }
        if (!model.body &&
            (model.method == HttpVerbs.POST ||
                model.method == HttpVerbs.PUT ||
                model.method == HttpVerbs.PATCH)) {
            throw new ValidationError('The HTTP Body is required when the method is POST or PUT or PATCH');
        }
        if (model.responseBodyVariable && !model.responseBodyVariable.match(VARIABLE_VALIDATION_REGEX)) {
            throw new ValidationError('The HTTP response body variable name should be composed only by letters, numbers and dots');
        }
        if (model.responseStatusVariable && !model.responseStatusVariable.match(VARIABLE_VALIDATION_REGEX)) {
            throw new ValidationError('The HTTP response status variable name should be composed only by letters, numbers and dots');
        }
    }
}
